import { render, staticRenderFns } from "./AltaImpagoMenu.vue?vue&type=template&id=7c7d866e&scoped=true&"
import script from "./AltaImpagoMenu.vue?vue&type=script&lang=js&"
export * from "./AltaImpagoMenu.vue?vue&type=script&lang=js&"
import style0 from "./AltaImpagoMenu.vue?vue&type=style&index=0&id=7c7d866e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7d866e",
  null
  
)

export default component.exports